import {
  customElement,
  FASTElement,
  Observable,
  observable,
  Splice,
} from '@microsoft/fast-element';
import { IBuyerAnalyticsService } from '../../../../../services';
import { VppaRankings } from '../../../../../types';
import { QuadrantGridTemplate as template } from './quadrant-grid.template';
import { QuadrantGridStyles as styles } from './quadrant-grid.styles';
import { ZeroGridPro as zeroAgGrid } from '@genesislcap/foundation-zero-grid-pro';

const name = 'quadrant-grid';

@customElement({
  name,
  template,
  styles,
})
export class QuadrantGrid extends FASTElement {
  @IBuyerAnalyticsService buyerAnalyticsService: IBuyerAnalyticsService;
  @observable selectedVppas: VppaRankings[] = [];
  @observable vppaQuadrantGrid: zeroAgGrid;
  @observable enableProceedButton: boolean = false;

  private notifier1: any;
  private handler1: any;

  connectedCallback(): void {
    super.connectedCallback();
    this.loadVppaRankings();
  }

  private loadVppaRankings() {
    const context = this;
    this.notifier1 = Observable.getNotifier(this.buyerAnalyticsService);
    this.handler1 = {
      handleChange(source: any, splices: Splice[]) {
        context.selectedVppas = source.selectedVppas;
      },
    };

    this.notifier1.subscribe(this.handler1, 'selectedVppas');
  }

  public selectedVppasChanged(oldValue, newValue: VppaRankings[]) {
    if (this.vppaQuadrantGrid) {
      this.setGridOptions();
    }
  }

  public setGridOptions() {
    this.vppaQuadrantGrid.gridOptions = {
      onGridReady: (grid) => {
        this.vppaQuadrantGrid.gridApi.setRowData(this.selectedVppas);
      },
      rowClass: 'transparent-background',
      defaultColDef: {
        resizable: true,
        wrapHeaderText: true,
        autoHeaderHeight: true,
      },
      tooltipShowDelay: 300,
      overlayNoRowsTemplate: `<span><span style="font-size: 15px; color: #879ba6; font-weight: 500">No Contracts Selected</span><br/><br/>Click contracts on the chart above to view comparative metrics between them</span>`,
    };
  }

  public proceedToNextStep() {
    this.buyerAnalyticsService.currentStep = 2;
  }

  disconnectedCallback(): void {
    super.disconnectedCallback();
    this.notifier1.unsubscribe(this.handler1);
  }
}
